import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { Badge, ErrorNote, fmtPKR, MONTHS } from '../components/ui.jsx';

const RUN_BADGE = { DRAFT: 'half-day', APPROVED: 'active', PAID: 'administrative' };

export default function Payroll() {
  const navigate = useNavigate();
  const now = new Date();
  const [runs, setRuns] = useState([]);
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => api('/payroll/runs').then(setRuns).catch((e) => setError(e.message));
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setBusy(true); setError('');
    try {
      const run = await api('/payroll/runs', { method: 'POST', body: { year, month } });
      navigate(`/payroll/${run.id}`);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">Generate Payroll</div>
        <div className="att-controls" style={{ marginBottom: 0 }}>
          <select className="filter-select" value={month} onChange={(e) => setMonth(Number(e.target.value))}>
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
          <select className="filter-select" value={year} onChange={(e) => setYear(Number(e.target.value))}>
            {[year - 2, year - 1, year, year + 1].filter((v, i, a) => a.indexOf(v) === i)
              .map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={generate} disabled={busy}>
            {busy ? 'Calculating…' : 'Generate / Recalculate'}
          </button>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Draft runs recalculate freely; approved runs are locked.
          </div>
        </div>
        <ErrorNote error={error} />
      </div>

      <div className="card emp-table-wrap">
        <div className="card-title">Payroll History</div>
        <table>
          <thead>
            <tr><th>Period</th><th>Status</th><th>Employees</th><th>Gross</th><th>Net Payable</th><th>Approved By</th></tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id} onClick={() => navigate(`/payroll/${r.id}`)}>
                <td className="fw-bold">{MONTHS[r.month - 1]} {r.year}</td>
                <td><Badge kind={RUN_BADGE[r.status]}>{r.status}</Badge></td>
                <td>{r.employeeCount}</td>
                <td>{fmtPKR(r.totalGross)}</td>
                <td className="text-green fw-bold">{fmtPKR(r.totalNet)}</td>
                <td className="text-muted">{r.approvedBy ?? '—'}</td>
              </tr>
            ))}
            {runs.length === 0 && (
              <tr><td colSpan={6}><div className="empty-state"><p>No payroll runs yet — generate the first one above.</p></div></td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
